// Reducer

import { REQUEST, SUCCESS, FAILURE } from 'app/shared/util/action-type.util';
import { GlobalObject } from '../../model/account.model';
import { ViewName } from '../../ui/tools/constants';
import { ACTION_TYPES } from './actions';
import { AccountState, initialState } from './state';

export default (state: AccountState = initialState, action): AccountState => {
  const mapValues = state.globalObject?.viewPayload;
  switch (action.type) {
    case REQUEST(ACTION_TYPES.GET_VIEW_CONFIG_RESPONSE):
      return {
        ...state,
        loadingView: true,
      };

    case SUCCESS(ACTION_TYPES.GET_VIEW_CONFIG_RESPONSE): {
      return {
        ...state,
        viewConfigResponse: action?.payload?.data,
        loadingView: false,
      };
    }

    case FAILURE(ACTION_TYPES.GET_VIEW_CONFIG_RESPONSE): {
      return {
        ...state,
        loadingView: false,
      };
    }

    case REQUEST(ACTION_TYPES.GET_SUBSCRIPTION_BY_CLIENT):
      return {
        ...state,
        loadingData: true,
        isReady: false,
      };

    case SUCCESS(ACTION_TYPES.GET_SUBSCRIPTION_BY_CLIENT): {
      return {
        ...state,
        subcriptionNotAttachedList: action?.payload?.data,
        loadingData: false,
        isReady: true,
      };
    }

    case FAILURE(ACTION_TYPES.GET_SUBSCRIPTION_BY_CLIENT): {
      return {
        ...initialState,
        loadingData: false,
        isReady: true,
      };
    }

    case REQUEST(ACTION_TYPES.GET_SUBSCRIPTION_BY_SUB_NUMBER):
      return {
        ...state,
        loadingData: true,
      };

    case SUCCESS(ACTION_TYPES.GET_SUBSCRIPTION_BY_SUB_NUMBER): {
      return {
        ...state,
        selectedContract: action?.payload?.data,
        loadingData: false,
      };
    }

    case FAILURE(ACTION_TYPES.GET_SUBSCRIPTION_BY_SUB_NUMBER): {
      return {
        ...state,
        selectedContract: null,
        loadingData: false,
      };
    }

    case REQUEST(ACTION_TYPES.VERIFY_SUBSCRIPTION):
      return {
        ...state,
        loadingData: true,
      };

    case SUCCESS(ACTION_TYPES.VERIFY_SUBSCRIPTION): {
      return {
        ...state,
        NumberVerfied: action?.payload?.data,
        loadingData: false,
      };
    }

    case FAILURE(ACTION_TYPES.VERIFY_SUBSCRIPTION): {
      return {
        ...state,
        NumberVerfied: false,
        loadingData: false,
      };
    }

    case REQUEST(ACTION_TYPES.VERIFY_OTP):
      return {
        ...state,
        loadingVerif: true,
      };

    case SUCCESS(ACTION_TYPES.VERIFY_OTP): {
      return {
        ...state,
        NumberVerfied: action?.payload?.data,
        loadingVerif: false,
      };
    }

    case FAILURE(ACTION_TYPES.VERIFY_OTP_CODE): {
      return {
        ...state,
        NumberVerfied: false,
        loadingData: false,
        loadingVerif: false,
        loadingSmsMail: false,
      };
    }

    case REQUEST(ACTION_TYPES.VERIFY_OTP_CODE):
      return {
        ...state,
        loadingVerif: true,
        loadingSmsMail: true,
      };

    case SUCCESS(ACTION_TYPES.VERIFY_OTP_CODE): {
      return {
        ...state,
        NumberVerfied: action?.payload?.data,
        loadingVerif: false,
        loadingSmsMail: false,
      };
    }

    case SUCCESS(ACTION_TYPES.EMPTY_FOUND_SUBSCRIPTION): {
      return {
        ...state,
        selectedContract: null,
      };
    }

    case FAILURE(ACTION_TYPES.VERIFY_OTP): {
      return {
        ...state,
        NumberVerfied: false,
        loadingVerif: false,
      };
    }
    case REQUEST(ACTION_TYPES.VERIFY_SPECIFIC):
      return {
        ...state,
        loadingVerif: true,
      };

    case SUCCESS(ACTION_TYPES.VERIFY_SPECIFIC): {
      return {
        ...state,
        NumberVerfied: action?.payload?.data,
        loadingVerif: false,
      };
    }

    case FAILURE(ACTION_TYPES.VERIFY_SPECIFIC): {
      return {
        ...state,
        NumberVerfied: false,
        loadingVerif: false,
      };
    }

    case ACTION_TYPES.CLEAN_VIEW_CONF:
      return {
        ...state,
        viewConfigResponse: null,
        NumberVerfied: null,
      };

    case ACTION_TYPES.CLEAN_NUMBER_VERIFIED:
      return {
        ...state,
        NumberVerfied: null,
      };

    case ACTION_TYPES.RESET_STATE:
      return { ...initialState, globalObject: new GlobalObject() };

    case ACTION_TYPES.UPDATE_VIEW_OBJECT:
      switch (action?.payload?.attributParam) {
        case 'array':
          return {
            ...state,
            globalObject: {
              ...state.globalObject,
              viewPayload: mapValues.set(action?.payload?.viewName, action?.payload?.viewObject),
            },
          };

        case 'attribut':
          return {
            ...state,
            [action?.payload?.viewName]: action?.payload?.viewObject,
          };
        default:
          return state;
      }

    case REQUEST(ACTION_TYPES.VERIF_PREVIOUS_MAIL):
      return {
        ...state,
        loadingCheckMail: true,
      };

    case SUCCESS(ACTION_TYPES.VERIF_PREVIOUS_MAIL):
      return {
        ...state,
        globalObject: {
          ...state.globalObject,
          viewPayload: mapValues.set(ViewName.SUBSCRIPTION_ACCOUNT_SEARCH, { emailChecked: action?.payload?.data }),
        },
        loadingCheckMail: false,
      };

    case FAILURE(ACTION_TYPES.VERIF_PREVIOUS_MAIL): {
      return {
        ...state,
        loadingCheckMail: false,
      };
    }
    default:
      return state;
  }
};
